import React, { useState, useEffect } from "react"
import Autocomplete from "@material-ui/lab/Autocomplete"
import Input from "../../../../Input/Input"
import { setCompany, setCompanyInput } from "../../useReducer/actionCreators"
import suggestionServices from "../../../../../services/suggestionServices"

const SUGGESTION_DELAY_MS = 250

/** Source/provider: the company that created the resource. */
const CompanyAutocomplete = ({ companyInput, externalDispatch }) => {
  const [options, setOptions] = useState([])
  useEffect(() => {
    let isCurrent = true
    const timer = setTimeout(() => {
      suggestionServices
        .getResourceCompanies(companyInput)
        .then(({ data }) => {
          if (isCurrent)
            setOptions((data || []).map(([name, id]) => ({ id, name })))
        })
        .catch(() => isCurrent && setOptions([]))
    }, SUGGESTION_DELAY_MS)
    return () => {
      isCurrent = false
      clearTimeout(timer)
    }
  }, [companyInput])
  return (
    <Autocomplete
      inputValue={companyInput}
      options={options}
      getOptionLabel={(option) => option.name}
      filterOptions={(items) => items}
      renderInput={(params) => (
        <div ref={params.InputProps.ref}>
          <Input
            type="text"
            label="Source / Provider"
            placeholder="All Sources"
            {...params.inputProps}
          />
        </div>
      )}
      onInputChange={(e, value) => {
        externalDispatch(setCompanyInput(value.substring(0, 32)))
      }}
      onChange={(e, company, reason) => {
        if (reason === "select-option") {
          externalDispatch(setCompany(company))
        }
      }}
    />
  )
}
export default CompanyAutocomplete
